import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function UnderstandingYourMigrationInvestment() {
  const factors = [{
    id: 1,
    title: "Migration Complexity",
    description: "The scope of your migration depends on your current GP configuration, customizations, and integrations. More complex setups require additional mapping and testing to ensure audit-ready results."
  }, {
    id: 2,
    title: "Data Volume",
    description: "The amount of historical data, transactional records, and master data directly impacts migration time and resource allocation. Larger datasets require more robust validation and quality checks."
  }, {
    id: 3,
    title: "Custom Requirements",
    description: "Specific reporting templates, branded outputs, and unique business processes add value but may extend timelines. Our team ensures every custom element meets your standards."
  }];
  return <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center animate-fade-in-up">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl lg:text-[2.25rem] leading-snug">
            Understanding Your Migration Investment
          </h2>
          <p className="mt-6 text-base leading-relaxed text-foreground/70 lg:text-lg">
            Several key factors influence the cost and timeline of your
            Microsoft Dynamics GP to Business Central migration. We provide
            transparent pricing starting at $7,500 CAD, tailored to your
            specific needs.
          </p>
        </div>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
          {factors.map((factor, i) => <div key={factor.id} data-index={i} className="card animate-fade-in-up-delay-100">
              <div className="p-8">
                <div className="mb-4 flex size-12 items-center justify-center rounded-md bg-primary-light-background">
                  <div className="size-6 rounded-sm bg-primary" />
                </div>
                <h3 className="text-xl font-semibold tracking-tight text-foreground">
                  {factor.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-foreground/70">
                  {factor.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 rounded-lg border border-border bg-primary-light-background p-8 shadow-soft animate-fade-in-up-delay-200 lg:p-12">
          <div className="flex flex-col items-center text-center lg:flex-row lg:text-left lg:items-start">
            <div className="flex-1">
              <h3 className="text-2xl font-bold tracking-tight text-foreground">
                Ready to Get Started?
              </h3>
              <p className="mt-4 text-base leading-relaxed text-foreground/70">
                Contact us today for a detailed consultation. Our team will
                assess your current GP setup and provide a customized migration
                plan with transparent pricing.
              </p>
            </div>
            <div className="mt-8 flex items-center gap-4 lg:mt-0 lg:ml-12">
              <Button asChild>
                <Link to="tel:(800) 555-1234">
                  Call Us
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}